<script lang="ts" setup>
import lang from '@arco-design/web-vue/es/locale/lang/zh-cn';

// 需要重新定义，否则类型报错
const zhCN = lang;

zhCN.datePicker.ok = '确认';
zhCN.modal.okText = '确认';
</script>

<template>
  <AConfigProvider :locale="zhCN">
    <RouterView />
  </AConfigProvider>
</template>
